import Carousel from "../modules/carousel";
import { newAiSearch, aiSearchEnabled } from "./ai-search";
import axios, { AxiosResponse } from "axios";
import * as queryString from "query-string";
import "custom-event-polyfill";
import $ from "jquery";

declare var searchInfo: any;

interface PropertiesResponse {
  html: string;
  total: number;
}

let currentSettings = {};
let first = true;
let initialHTML = "";

const setup = () => {
  const container = document.getElementById("supercontrol-properties-list");
  if (typeof (window as any).siteInfo === "undefined") {
    return;
  }

  $(document).on("change", "[data-submit-on-change]", onChange);
  document.addEventListener(
    "gloversure.accommodation.trigger.search",
    (e: CustomEvent) => {
      doSearch(e.detail.newSearch);
    },
  );
  initialHTML = container.innerHTML;

  doSearch();

  const selectors: string[] = [
    "#supercontrol-search-form",
    "#quick-search-form",
    "[data-submit-form]",
  ];

  const forms: HTMLFormElement[] = [];

  selectors.forEach((selector) => {
    if ($(selector)) {
      $(selector).each((index: number, form: HTMLFormElement) => {
        forms.push(form);
      });
    }
  });

  forms.forEach((form) => {
    $(form).on("submit", (evt: any) => {
      onFormSubmit(evt, forms, container);
      document.dispatchEvent(
        new Event("gloversure.accommodation.search.first-load"),
      );
    });
  });
};

function doSearch(
  settings: Record<string, any> = {},
  page: string | number | false = false,
) {
  const updatedSettings: Record<string, any> = {
    ...settings,
  };
  if (page) {
    updatedSettings.showpage = page;
  }
  if ("q" in settings || (!("q" in settings) && aiSearchEnabled())) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(updatedSettings)) {
      formData.append(key, value);
    }
    newAiSearch(formData);
  } else {
    newSearch(updatedSettings);
  }
}

function onChange(evt: any) {
  const { target } = evt;

  const searched = {
    ...queryString.parse(window.location.search),
    ...(window as any).searched,
  };
  const name = target.name;

  if (name.includes("[]")) {
    const values: string[] = [];
    $(`input[name='${name}']:checked`).each((index, element) => {
      const input = element as HTMLInputElement;
      values[index] = input.value;
    });
    searched[name] = values;
  } else {
    const value =
      target.type !== "select-one"
        ? target.value
        : target.selectedOptions[0].value || "";
    searched[name] = value;
  }

  doSearch(searched);
}

function onFormSubmit(evt: any, searchForms: any[], container: any) {
  evt.preventDefault();

  const options: any = {};
  searchForms.forEach((searchForm) => {
    if (searchForm == null) return;
    const data = new FormData(searchForm);

    for (const key of data.keys()) {
      if (key.indexOf("[]") !== -1) {
        const existing =
          typeof options[key] !== "undefined" ? [...options[key]] : [];
        options[key] = [...new Set([...data.getAll(key), ...existing])];
        if (options[key].filter((item: any) => item).length === 0)
          delete options[key];
      } else {
        options[key] = data.get(key);
      }
    }
  });

  newSearch(options);
  window.scrollTo({
    top: container.offsetTop - 100,
    behavior: "smooth",
  });
}

function setupPaginate() {
  const list = document.querySelectorAll(".paginate__number");
  const container = document.getElementById("supercontrol-properties-list");
  list.forEach((item: HTMLElement) => {
    item.addEventListener("click", (evt) => {
      evt.preventDefault();
      const target: HTMLElement = evt.target as HTMLElement;
      const settings = queryString.parse(window.location.search);
      doSearch(settings, target.dataset["page"]);
      window.scrollTo({
        top: container.offsetTop - 100,
        behavior: "smooth",
      });
    });
  });
}

interface CurrentSettingsType {
  [keys: string]: any | any[];
}

function newSearch(newOptions: any = {}) {
  const searchInfo = (window as any).searchInfo;
  const searched =
    typeof (window as any).searched === "object"
      ? (window as any).searched
      : {};
  const querySearched = queryString.parse(location.search);
  const includedGet = first ? querySearched : {};
  let currentSettings: CurrentSettingsType = {};

  const popupFiltersForm = document.getElementById("filters-popup");
  const filters: Record<string, any> = { "variables[]": [] };
  if (popupFiltersForm != null) {
    let inps = $(popupFiltersForm).find("input");

    Array.from(inps).forEach((inp: HTMLInputElement) => {
      if (inp.type == "checkbox") {
        if (inp.checked) {
          filters["variables[]"].push(inp.value);
        }
      } else {
        if (
          (inp.getAttribute("type") == "number" && Number(inp.value) > 0) ||
          inp.getAttribute("type") != "number"
        ) {
          filters[inp.name] = inp.value;
        }
      }
    });
  } else {
    delete filters["variables[]"];
  }

  if (
    searchInfo.override_inspirations == "yes" &&
    newOptions["showpage"] == undefined
  ) {
    const skipOverride = ["user_favourites", "has_discount"];

    // If the new search empties the values of default search
    // filters params that are set to skip the override
    Object.keys(searched)
      .filter((item) => !skipOverride.includes(item))
      .map((item) => {
        if (newOptions && !newOptions[item] && !first) {
          searched[item] = "";
          includedGet[item] = "";
        }
      });

    currentSettings = {
      ...includedGet,
      ...filters,
      ...searched,
      ...newOptions,
    };
  } else {
    // The order of these settings are important
    // The last settings will overwrite the previous settings
    currentSettings = {
      ...includedGet,
      ...newOptions,
      ...filters,
      ...searched,
    };
  }
  if (searchInfo.override_inspirations == "no") {
    const variables: any = [];
    [includedGet, filters, searched, newOptions].forEach((dataToCheck: any) => {
      if (!dataToCheck["variables[]"]) {
        return;
      }
      if (!Array.isArray(dataToCheck["variables[]"])) {
        variables.push(dataToCheck["variables[]"].toString());
        return;
      }
      dataToCheck["variables[]"].forEach((arrayElem: any) => {
        variables.push(arrayElem.toString());
      });
    });
    currentSettings["variables[]"] = variables;
  }
  if ("variables" in currentSettings && "variables[]" in currentSettings) {
    if (Array.isArray(currentSettings["variables[]"])) {
      currentSettings["variables[]"].push(currentSettings["variables"]);
    } else {
      currentSettings["variables[]"] = [
        currentSettings["variables[]"],
        currentSettings["variables"],
      ];
    }
    delete currentSettings.variables;
    currentSettings["variables[]"] = [
      ...new Set(currentSettings["variables[]"]),
    ];
  }
  currentSettings["variables[]"] = typeof currentSettings["variables[]"] === 'string' 
    ? [currentSettings["variables[]"]]
    : [...new Set(currentSettings["variables[]"])];

  if (!first) {
    setSearchLoading();
  }

  const cleanedOptions = cleanObject(currentSettings);

  setQueryString(cleanedOptions);

  const event = new CustomEvent(
    "gloversure.accommodation.property-list.start_search",
    {
      detail: {
        newSearch: cleanedOptions,
      },
    },
  );
  document.dispatchEvent(event);

  callAccommodationApi(
    `/wp-json/accommodation/properties?${queryString.stringify(cleanedOptions)}`,
  );
}

export function setQueryString(cleanedOptions: Record<string, any>) {
  const container = document.getElementById("supercontrol-properties-list");
  if (Object.keys(cleanedOptions).length > 0 && !first && container) {
    window.history.pushState(
      {
        path: "?" + queryString.stringify(cleanedOptions),
      },
      "",
      "?" + queryString.stringify(cleanedOptions),
    );
    window.dispatchEvent(new Event("location.change"));
  }
}

export function setSearchLoading() {
  const container = document.getElementById("supercontrol-properties-list");
  let content = initialHTML;
  if ((window as any).loader) {
    content = (window as any).loader;
  }
  container.classList.remove("loaded");
  container.classList.add("loading");
  container.innerHTML = content;
}

export function callAccommodationApi(
  route: string,
  formData: FormData | null = null,
  successfulCallback: (result: any) => void = (result: any) => { },
  runUpdatePropertiesList: boolean = true,
) {
  const siteInfo = (window as any).siteInfo;
  let method = "get";
  if (formData !== null) {
    method = "post";
  }
  const eventToDispatch = new CustomEvent(
    "gloversure.accommodation.property-list.start_search",
  );
  document.dispatchEvent(eventToDispatch);
  fetch(`${siteInfo.url}${route}`, {
    method: method,
    body: formData,
  })
    .then((response: Response) => {
      return response.json();
    })
    .then((data: PropertiesResponse) =>
      runUpdatePropertiesList ? updatePropertiesList(data) : data,
    )
    .then((data: PropertiesResponse) => {
      const eventToDispatch = new CustomEvent(
        "gloversure.accommodation.property-list.load",
      );
      document.dispatchEvent(eventToDispatch);
      return data;
    })
    .then(successfulCallback);
}

function updatePropertiesList(data: PropertiesResponse) {
  const container = document.getElementById("supercontrol-properties-list");
  initialHTML = container.innerHTML;
  container.innerHTML = data.html;
  container.classList.remove("loading");
  container.classList.add("loaded");

  Carousel.setup(".slick", {
    delay: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyload: "ondemand",
    speed: 300,
    arrows: true,
    prevArrow:
      '<div class="slider-arrow slider-prev fa-solid fa-angle-left"></div>',
    nextArrow:
      '<div class="slider-arrow slider-next fa-solid fa-angle-right"></div>',
  });

  setupPaginate();

  const event = new CustomEvent(
    "gloversure.accommodation.property-container.load",
    {
      detail: {
        first,
        total: data.total,
      },
    },
  );
  document.dispatchEvent(event);
  first = false;

  return data;
}

function cleanObject(obj: any) {
  for (let key in obj) {
    if (typeof obj[key] === "string") {
      obj[key] = obj[key].trim();
    }
    if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }

  return obj;
}

if (typeof (window as any).Gloversure === "undefined")
  (window as any).Gloversure = {};

(window as any).Gloversure.properties = {
  newSearch,
};

export default {
  setup,
};
